<template>
  <div class="card" v-bind="$attrs" v-on="$listeners">
    <div class="title-card">{{ title }}</div>
    <div class="content-card">
      <v-icon :color="icon.color">{{ icon.icon }}</v-icon>
      <span>{{ value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    icon: {
      type: Object,
      default: () => ({ icon: "", color: "" })
    },
    value: { type: [String, Number], required: true }
  }
};
</script>

<style>
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
.title-card {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  color: #4b5563;
}

.content-card {
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 500;
  display: flex;
  gap: 0.25rem;
}
</style>
